import { Box } from "grommet";
import React from "react";
import { Timeline, TimelineEvent } from "react-event-timeline";
import { EventTimelineType } from "./typings/EventTimelineType";

type EventTimelineProps = {
  events: EventTimelineType[];
};

function EventTimeline({ events }: EventTimelineProps) {
  return (
    <Box style={{width: '100%', padding: 16, paddingTop: 0, marginTop: 16}} overflow={"auto"}>
      <Timeline style={{padding: 0}} lineStyle={{border: "1px dashed #ccc", borderSpacing: 5}}>
        {events.map((event) => {
          return (
            <TimelineEvent
              title={
                <div style={{ marginBottom: "5px" }}>
                  <div style={{ color: "#4B628A", fontFamily: "Inter", fontSize: 12, fontStyle: "normal", fontWeight: "600" }}>
                    {event.title}
                  </div>
                  <div style={{ color: "#A7B6D1", fontSize: 10,fontFamily: "Inter",fontStyle: "normal", fontWeight: "500" }}>
                    {event.createdAt}
                  </div>
                </div>
              }
              icon={event.icon}
            >
              {event.description}
            </TimelineEvent>
          );
        })}
      </Timeline>
    </Box>
  );
}

export default EventTimeline;
